import { render, staticRenderFns } from "./FormEditor.vue?vue&type=template&id=1ff715a9"
import script from "./FormEditor.ts?vue&type=script&lang=ts"
export * from "./FormEditor.ts?vue&type=script&lang=ts"
import style0 from "./FormEditor.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.0.10@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports